import React, { JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, ButtonProps, Container, Stack, Typography } from '@mui/material';
import professionalConversationPng from 'assets/Conversation.png';
import { Beta } from 'components/ui/Beta';
import { HeroSection, HeroStyledButton } from './HowItWorksLayout';

interface HeroButtonProps extends ButtonProps {
  children?: string;
  path: string;
}

function HeroButton(props: HeroButtonProps): JSX.Element {
  const { children, onClick, path, ...rest } = props;
  const navigate = useNavigate();

  return (
    <HeroStyledButton onClick={onClick ? onClick : () => navigate(path)} {...rest}>
      {children}
    </HeroStyledButton>
  );
}

export function HowItWorksHero(): JSX.Element {
  return (
    <>
      <HeroSection>
        <Container>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              gap: 4,
              alignItems: 'center',
              flexGrow: 1,
              maxWidth: '1024px',
            }}
          >
            <Box sx={{ flex: 1, flexGrow: 1 }}>
              <Typography
                variant="h2"
                component="h1"
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: '1.25rem', md: '1.75rem' },
                  mb: 2,
                  color: 'white',
                }}
              >
                Your complete professional story, beyond a single page
              </Typography>
              <Typography
                variant="h5"
                sx={{ mb: 3, fontWeight: 400, fontSize: { xs: '1rem', md: '1.25rem' } }}
              >
                Let potential employers discover the depth of your experience through interactive
                Q&A and tailored resumes
              </Typography>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <HeroButton variant="contained" size="large" path="/login/register">
                  Get Started as Candidate
                </HeroButton>
              </Stack>
            </Box>
            <Box sx={{ justifyContent: 'center', display: { xs: 'none', md: 'block' } }}>
              <Box
                component="img"
                src={professionalConversationPng}
                alt="Professional conversation"
                sx={{ width: '100%', maxWidth: 200, height: 'auto', borderRadius: 2, boxShadow: 3 }}
              />
            </Box>
          </Box>
        </Container>
      </HeroSection>
      <HeroSection
        sx={{
          display: 'flex',
          position: 'relative',
          overflow: 'hidden',
          border: '2px solid orange',
        }}
      >
        <Beta adaptive={false} sx={{ left: '-90px' }} />
        <Container sx={{ display: 'flex', position: 'relative' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'center',
              maxWidth: 800,
              mx: 'auto',
              position: 'relative',
            }}
          >
            <Typography
              variant="h2"
              component="h1"
              sx={{
                fontWeight: 700,
                fontSize: { xs: '2rem', md: '2.5rem' },
                mb: 2,
                color: 'white',
              }}
            >
              Welcome to the Backstory Beta!
            </Typography>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 400 }}>
              Here are your steps from zero-to-hero to see Backstory in action
            </Typography>
          </Box>
        </Container>
      </HeroSection>
    </>
  );
}
